import React, { createContext, useEffect, useState, useContext } from "react";
import * as ScenarioAPI from '../services/ScenarioServices';
import AuthContext from "./AuthContext";

const PermissionsContext = createContext();

function PermissionsContextProvider(props) {
    const { user, loggedIn } = useContext(AuthContext);
    const [scenarioCount, setScenarioCount] = useState(0);

    const fetchScenarioLength = async () => {
        if (!loggedIn) {
            setScenarioCount(0);
            return;
        }
        try {
            const data = await ScenarioAPI.getMyScenarios();
            setScenarioCount(data.length);
        } catch (err) {
            console.error("Error fetching scenario length:", err);
            setScenarioCount(0);
        }
    };

    useEffect(() => {
        fetchScenarioLength();
    }, [loggedIn]);

    return (
        <PermissionsContext.Provider
            value={{
                fetchScenarioLength,
                scenarioCount,
                setScenarioCount,
            }}
        >
            {props.children}
        </PermissionsContext.Provider>
    );
}

export default PermissionsContext;
export { PermissionsContextProvider };
